import { sharedSelectors } from 'shared-lib'
import * as applicationSelectors from './application/application.selectors'
import * as jobSelectors from './job/job.selectors'
import * as profileSelectors from './profile/profile.selectors'
import * as resumeSelectors from './resume/resume.selectors'
import * as videoSelectors from './video/video.selectors'

export const selectors = { ...sharedSelectors, ...jobSelectors, ...profileSelectors, ...resumeSelectors, ...videoSelectors, ...applicationSelectors }
